import type { SearchFilters } from '../ExploreListings/types';
import type { OffMarketWillingnessEvent } from '../utils/types';
import type { AreaDemandCard } from '../AppContent/NewLandingPage/CouldBuyFlow/areaInterestApi';
import { classifyDetails, classifyWillingness, MatchStatus } from '../ExploreListings/matchDetails';

/** Classify the complete preview response so clearing filters restores rows at
 * once, including rows that arrived after a preview opened. */
export const filterPreviewListings = (
  listings: OffMarketWillingnessEvent[],
  areaDemand: AreaDemandCard[],
  filters: SearchFilters,
) => {
  const allowed = (status: MatchStatus): status is 'confirmed' | 'unconfirmed' => status === 'confirmed' ||
    (filters.includeIncompleteDetails && status === 'unconfirmed');
  const visibleListings = listings.flatMap((listing) => {
    const assessment = classifyWillingness(listing, filters);
    const status = assessment.status;
    return allowed(status) ? [{
      ...listing,
      match_status: status,
      unconfirmed_fields: assessment.unconfirmedFields,
      match_kind: assessment.kind,
    }] : [];
  });
  const visibleAreaDemand = filters.listingType === 'sell' ? [] : areaDemand.flatMap((area) => {
    const assessment = classifyDetails(area, filters, 'buyer');
    const status = assessment.status;
    return allowed(status) ? [{
      ...area,
      match_status: status,
      unconfirmed_fields: assessment.unconfirmedFields,
    }] : [];
  });
  return {
    listings: visibleListings,
    areaDemand: visibleAreaDemand,
    hasFilteredListings:
      visibleListings.length < listings.length ||
      visibleAreaDemand.length < areaDemand.length,
  };
};
